import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-functional-map',
  templateUrl: './functional-map.component.html',
  styleUrls: ['./functional-map.component.scss']
})
export class FunctionalMapComponent implements OnInit {
  icon: string;
  constructor() {
    
   }

  ngOnInit() {
    this.icon="fa fa-angle-right float-right";
  }

  changeIcon(){
    switch (this.icon) {
      case "fa fa-angle-right float-right":
        this.icon="fa fa-angle-down float-right";
      break;
      case "fa fa-angle-down float-right":
          this.icon="fa fa-angle-right float-right";
      break;
    }
  }
}
